
import React from 'react';
import WithdrawalSettingComponent from '../../../Components/WithdrawalSetting/WithdrawalSetting';

export default function WithdrawalSetting() {
    return (
        <div className='page-body'>
            <WithdrawalSettingComponent />
        </div>
    );
}